export const T = {
  en_GB: {
    verifiedIdPeople: "Verified ID, per person",
    verifiedId: "ID verified",
    notVerified: "ID not verified",
  },
  nb_NO: {
    verifiedIdPeople: "Verifisert ID, per person",
    verifiedId: "ID verifisert",
    notVerified: "ID ikke verifisert",
  },
} as const;
